import React from 'react';
import { Box } from '@tanium/react-box';
import { Id } from '../../types/Id';
import { StackedRibbonListVirtualizedProps } from '../../types/StackedRibbonListComponentTypes';
import { RibbonListVirtualizedHandles } from '../List/RibbonListHandles';
import { StackedRibbonListMinimalVirtualized } from '../Minimal/StackedRibbonListMinimalVirtualized';
import { ResultsHeaderWrapper } from '../ResultsHeader/ResultsHeaderWrapper';
import { useResultsHeaderWrapper } from '../ResultsHeader/useResultsHeaderWrapper';
import { useVirtualizedStackedRibbonList } from './useVirtualizedStackedRibbonList';

/**
 * A StackedRibbonList with a header section whose contents are virtualized in the DOM.
 */
export const StackedRibbonListVirtualized = React.memo(
  React.forwardRef(
    <TId extends Id, TItem>(
      props: StackedRibbonListVirtualizedProps<TId, TItem>,
      ref: React.Ref<RibbonListVirtualizedHandles>,
    ) => {
      const headerWrapperProps = useResultsHeaderWrapper(props);
      const virtualizedRibbonListProps = useVirtualizedStackedRibbonList(props);

      const { height = '500px' } = props;

      return (
        <ResultsHeaderWrapper {...headerWrapperProps}>
          <Box height={height}>
            <StackedRibbonListMinimalVirtualized {...virtualizedRibbonListProps} ref={ref} />
          </Box>
        </ResultsHeaderWrapper>
      );
    },
  ),
) as <TId extends Id, TItem>(
  props: StackedRibbonListVirtualizedProps<TId, TItem> & {
    ref?: React.Ref<RibbonListVirtualizedHandles>;
  },
) => JSX.Element;
